<style>
    .logined-phone .remind {
        margin-top: -12px;
        font-size: 14px;
        color: #4990E2;
    }
    .logined-phone .remind .tx {
        font-size: 12px;
        color: #D0011B;
        display: inline-block;
        margin-left: 20px;
    }
    .logined-phone .bombbox {
        border-radius: 10px;
        width: 100%;
    }
    .logined-phone .input-form {
        margin-top: 20px;
        padding: 0;
    }
    @media (min-width: 768px) {
        .logined-phone .bombbox {
            width: 410px;
        }
        .logined-phone .input-form {
            padding: 0 73px;
        }
    }
    .logined-phone .yan-zh {
        width: 126px;
        margin-right: 20px;
    }
    .logined-phone .que-button {
        width: 78px;
        height: 36px;
    }
    .logined-phone .footer {
        text-align: center;
        margin-top: -40px;
    }


</style>
<template>
    <div class="logined-phone">
        <el-dialog title="账户安全" :close-on-click-modal=false :show-close=false :visible="myResult" custom-class="bombbox">
            <div class="remind">验证操作<span class="tx">绑定后可直接使用已绑定信息登录</span></div>
            <div class="input-form">
                <el-select v-model="validate_way" placeholder="请选择验证方式" style="width: 100%">
                    <el-option label="手机验证" value="1"></el-option>
                    <el-option label="邮箱验证" value="2"></el-option>
                </el-select>
            </div>
            <div v-if="validate_way==1">
                <el-form :model="form1" ref="form1" class="input-form">
                    <el-form-item>
                        <el-input v-model="form1.phone" placeholder="输入手机号"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="form1.captcha" placeholder="短信验证码" class="yan-zh"></el-input>
                        <el-button type="text" class="get-button" @click="getCaptcha"
                                   :disabled="phone_pb_disabled">
                            {{ phone_pb_show}}
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div v-else>
                <el-form :model="form2" ref="form2" class="input-form">
                    <el-form-item>
                        <el-input v-model="form2.email" placeholder="输入邮箱"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="form2.captcha" placeholder="邮箱验证码" class="yan-zh"></el-input>
                        <el-button type="text" class="get-button" @click="getCaptcha"
                                   :disabled="pb_disabled">
                            {{ pb_show}}
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer footer">
                <el-button type="primary" class="que-button" @click="bundingAc">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script type="text/ecmascript-6">
    export default{
        data: function () {
            var validateEmail = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入邮箱'));
                }
                else if (!this.$common.validEmail(value)) {
                    callback(new Error('邮箱号错误,请重新填写'));
                }
                else {
                    callback()
                }
            };
            var validatePhone = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入手机号'));
                }
                else if (!(/^1(3|4|5|7|8|6|9)\d{9}$/.test(value))) {
                    callback(new Error('手机号错误,请重新填写'));
                }
                else {
                    callback()
                }
            };
            return {
                form1: {
                    phone: '',
                    captcha: '',
                },
                from1_rules: {
                    phone: [{required: true, validator: validatePhone, trigger: 'blur'}],
                    captcha: [{required: true, message: '请输入动态码', trigger: 'blur'}]
                },
                form2: {
                    email: '',
                    captcha: '',
                },
                from2_rules: {
                    email: [{required: true, validator: validateEmail, trigger: 'blur'}],
                    captcha: [{required: true, message: '请输入动态码', trigger: 'blur'}]
                },
                myResult: this.dialogFormVisible,
                validate_way: '1',
                phone_pb_disabled: false,
                phone_pb_show: '获取验证码',
                pb_disabled: false,
                pb_show: '获取验证码',
            }
        },
        props: {
            dialogFormVisible: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            dialogFormVisible(val) {
                this.myResult = val;
            },
            myResult(val){
                this.$emit("on-result-change", val);
            }
        },
        methods: {
            getCaptcha: function () {
                if (this.validate_way == 1) {
                    this.$http.post(globalProvider.serviceUrl('ea/sso/c/m/dc/inf'), {
                        ac: this.form1.phone,
                    })
                        .then((data) => {
                            this.phone_pb_disabled = true;
                            let time = 60;
                            if (data.body.code == resultCode.Success) {
                                this.phone_pb_show = time + 1;
                                for (let i = 0; i <= time; i++) {
                                    window.setTimeout(()=> {
                                        --this.phone_pb_show;
                                        if (this.phone_pb_show == 0) {
                                            this.phone_pb_show = '重新发送';
                                            this.phone_pb_disabled = false;
                                        }
                                    }, i * 1000)
                                }
                            }
                        })
                }
                else {
                    this.$http.post(globalProvider.serviceUrl('ea/sso/c/e/dc/inf'), {
                        ac: this.form2.email,
                    })
                        .then((data) => {
                            this.pb_disabled = true;
                            let time = 60;
                            if (data.body.code == resultCode.Success) {
                                this.pb_show = time + 1;
                                for (let i = 0; i <= time; i++) {
                                    window.setTimeout(()=> {
                                        --this.pb_show;
                                        if (this.pb_show == 0) {
                                            this.pb_show = '重新发送';
                                            this.pb_disabled = false;
                                        }
                                    }, i * 1000)
                                }
                            }
                        })
                }
            },
            bundingAc: function () {
                if (this.validate_way == 1) {
                    this.$refs.form1.validate((valid) => {
                            if (valid) {
                                this.$http.post(globalProvider.serviceUrl('ea/sso/v/m/dc/inf'), {
                                    ac: this.form1.phone,
                                    dc: this.form1.captcha
                                })
                                    .then((data) => {
                                        if (data.body.code == resultCode.Success) {
                                            this.myResult = true;
                                        }
                                    })
                            }
                        }
                    )
                }
                else {
                    this.$refs.form2.validate((valid) => {
                        if (valid) {
                            this.$http.post(globalProvider.serviceUrl('ea/sso/v/e/dc/inf'), {
                                ac: this.form1.email,
                                dc: this.form1.captcha
                            })
                                .then((data) => {
                                    if (data.body.code == resultCode.Success) {
                                        this.myResult = true;
                                    }
                                })
                        }
                    })
                }
            },
        }
    }
</script>